import clsx from 'clsx'
import { Icon } from '@iconify/react'
import { ColumnsType } from 'antd/lib/table'
import { Button } from '@pepper/ui'

import KeywordDetailsPopover from 'components/idea-lab/details-popover/KeywordDetailsPopover'
import GoogleRankPill from 'components/idea-lab/GoogleRankPill'
import VolumePill from 'components/idea-lab/VolumePill'
import IntentPill from 'components/idea-lab/IntentPill'

import KeywordDifficulty from '../../Keywords/KeywordDifficulty'

import { KeywordLabel, SuggestedKeyword } from 'types/keyword'

import s from './KeywordSuggestionsTable.module.css'

type Props = {
  companyId: string
  isGoogleConnected: boolean
  isDomainRemoved: boolean
  isLoadingKeywordLabel: boolean
  disableCta: boolean
  isContentIdeasPage: boolean
  onGetKeywordLabel: (suggestionId: string) => void
  handleAddToProject: (keyword: SuggestedKeyword) => Promise<void>
  pageRankingResults?: KeywordLabel
  domain?: string
}

export const getColumns = <RecordType extends SuggestedKeyword>({
  isLoadingKeywordLabel,
  disableCta,
  handleAddToProject,
  onGetKeywordLabel,
  pageRankingResults,
  domain,
  companyId,
  isGoogleConnected,
  isDomainRemoved,
  isContentIdeasPage,
}: Props): ColumnsType<RecordType> => {
  return [
    {
      title: 'Keywords',
      className: s.cell,
      render: (_, record) => (
        <KeywordDetailsPopover
          isLoading={isLoadingKeywordLabel}
          onGetKeywordLabel={() => onGetKeywordLabel(record.id)}
          keywordLabel={pageRankingResults}
          topSearchResults={pageRankingResults?.top_ranking_details}
          selfRankingPages={pageRankingResults?.self_ranking_pages}
          domain={domain}
          primaryKeyword={record.keyword}
          updatedAt={pageRankingResults?.updated_at}
          isDomainRemoved={isDomainRemoved}
          isGoogleConnected={isGoogleConnected}
          companyId={companyId}
        >
          <div className={s.wrapper}>
            {record.keyword}{' '}
            <Icon
              icon="lucide:chevrons-right"
              className={s.popoverIcon}
              height={20}
              width={20}
            />
            {record.intent?.split(',')?.map(intent => (
              <IntentPill key={intent} value={intent} />
            ))}
            {record?.self_top_position && (
              <GoogleRankPill googleRank={record.self_top_position} />
            )}
          </div>
        </KeywordDetailsPopover>
      ),
    },
    {
      title: 'Volume',
      className: clsx(s.cell, s.right),
      render: (_, record) => <VolumePill value={record.volume} />,
      width: 80,
    },
    {
      title: <div className={s.right}>Difficulty</div>,
      className: clsx(s.cell, s.right),
      render: (_, record) => (
        <div className={s.difficulty}>
          <KeywordDifficulty difficulty={record.difficulty} />
        </div>
      ),

      width: isContentIdeasPage ? 130 : 115,
    },
    {
      title: '',
      className: clsx(s.cell, s.right),
      width: isContentIdeasPage ? 190 : 180,
      render: (_, record) => (
        <Button
          type="link"
          icon={<Icon icon="lucide:plus" />}
          onClick={() => handleAddToProject(record)}
          disabled={disableCta}
        >
          Add to Project
        </Button>
      ),
    },
  ]
}
